module.exports = __webpack_public_path__ + "media/images/icon_calendar-a831304c1abc80d083b3a5b711ce8b02.svg";